import type { VTour } from '@globalhive/vuejs-tour';
import type { ITourStep } from 'node_modules/@globalhive/vuejs-tour/dist/Types';

export type TourStep = ITourStep;
export type VTourComponent = InstanceType<typeof VTour>;

export const manualTourSteps: TourStep[] = [
    {
        target: '#pickOrganizationMenu',
        content: 'Met dit menu kunt u het bedrijf/de vestiging wisselen waarvan u de gegevens bekijkt.'
    },
    {
        target: '.notification-bell',
        content:
            'Door hierop te klikken kunt u uw notificaties lezen. U krijgt een notificatie als er iets belangrijks plaatsvindt, bijvoorbeeld als een actiepunt aan u is toegewezen. Als er ongelezen notificaties zijn kunt u dit zien aan het aantal wat ernaast staat.'
    },
    {
        target: '#profileNavItem',
        content:
            'Door te klikken op uw naam in het menu kunt u uw profiel bekijken en aanpassen. Hier kunt u ook uw e-mailadres en wachtwoord wijzigen.'
    },
    {
        target: '#dashboardNavItem',
        content:
            'Op het dashboard kunt u statistieken bekijken van het huidige bedrijf. Op de meeste grafiekonderdelen kunt u klikken om naar de actielijst te gaan en deze actiepunten te bekijken.'
    },
    {
        target: '#actionListNavItem',
        content: '' // redirects to action list page, but still need an item for it here so the index is correct for the other items
    },
    {
        target: '#modulesNavItem',
        content: 'Via dit menu kunt u de modules gebruiken waarover uw bedrijf beschikt. Modules voegen extra functionaliteiten toe aan Incontrol.'
    },
    {
        target: '#orgNavItem',
        content: 'Via dit menu kunt u de informatie, medewerkers en onderliggende vestigingen bekijken van het huidige bedrijf.'
    },
    {
        target: '#teamsNavItem',
        content:
            'Een team is een groep van medewerkers die toegewezen kan worden aan een actiepunt. Op deze pagina ziet u een overzicht van de teams binnen het huidige bedrijf waar u toegang tot heeft.'
    }
];

export const actionPointListTourSteps: TourStep[] = [
    {
        target: '#actionListNavItem',
        content: 'Hier ziet uw een lijst met actiepunten van het huidige bedrijf.'
    },
    {
        target: '.v-data-table__tr:first-child',
        content: 'Meer details over een actiepunt kunt u bekijken door op een actiepunt in de lijst te klikken.'
    },
    {
        target: '.filter-icon',
        content: 'U kunt de lijst van actiepunten filteren door op het filter icoon te klikken en één of meerdere filtercriteria te kiezen.'
    },
    {
        target: '.v-data-table__th--sorted',
        content: 'U kunt de tabelkolommen sorteren door op de kolomnaam te klikken.'
    },
    {
        target: '.item-number',
        content: 'Het nummer van een actiepunt is een oplopend volgnummer per bedrijf/vestiging'
    },
    {
        target: '#actionPointStatusMenu',
        content: 'De status van een actiepunt kan snel aangepast worden door op de status te klikken en een nieuwe status te kiezen.'
    }
];

export const actionPointListAdminTourSteps = [
    {
        target: '#importActionPointsButton',
        content:
            'Beheerders kunnen actiepunten importeren. Importeren is mogelijk met RI&E Excel-bestanden van \'t Web. Het is ook mogelijk om een eigen Excel-bestand te importeren, dit kunt u doen door de instellingen aan te passen onder het uitklapmenu "Geavanceerd" nadat u heeft geklikt op de importeerknop.'
    }
];
